export const SPACE_LOGO_COLORS = [
    '177BF5', 'FFA114', 'F42F9A', 'BECB12', '39BADA',
    '4567E5', '8433F7', 'CE0003', 'FF6E00', '5BD3B3',
    '1D607A', '4D5661', '83654C', '66C568', '661100',
];

export const createWorkspaceLogoResources = (resourcePath) => ({
    SPACE_LOGO_COLORS,
    SPACE_LOGO: SPACE_LOGO_COLORS.reduce((acc, color) => ({
        ...acc,
        [color]: resourcePath + `images/common/space/ws_${color}.svg`,
    }), {}),
});
